<template>
  <div>
    <v-select v-if="$vuetify.breakpoint.xsOnly" outlined :items="selectItems" v-model="currentValue"></v-select>
    <v-tabs v-else v-model="currentValue">
      <v-tab v-for="item of items" :key="item">{{ item }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'TabSelect',
  props: ['items', 'value'],
  data () {
    return {
      currentValue: this.value,
    }
  },
  watch: {
    currentValue () {
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    }
  },
  computed: {
    selectItems () {
      let i = 0
      return this.items.map(item => {
        return {
          text: item,
          value: i++
        }
      })
    }
  }
}
</script>

<style scoped>

</style>